import { normalize } from 'normalizr';
import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import mapKeys from 'lodash/mapKeys';
import { entitiesDelete, entitiesReceive } from './actions';
import * as schemas from './schemas';

const lowercaseKeys = obj => mapKeys(obj, (v, k) => k.toLowerCase());
const middleware = store => next => action => {
  let { payload, meta } = action;

  if (meta && meta.entities) {
    const camelEntity = camelCase(meta.entities);
    const schema = schemas[camelEntity];

    if (schema) {
      // https://inmarket.atlassian.net/browse/IM-2034
      if (Array.isArray(payload)) {
        payload = payload.map(lowercaseKeys);
      }

      if (
        get(action, 'meta.request.params.page_size', false) &&
        typeof payload === 'object' &&
        isEmpty(payload)
      ) {
        payload = [];
      }

      // This is a delete action so remove it from entities
      if (payload === undefined && action.type === 'RESOURCE_DELETE_SUCCESS') {
        // The one delete that should not remove entities. This is because the polling after a delete will remove it manually
        if (get(action, 'meta.entities') !== 'advertiser-ad/audiences') {
          payload = get(action, 'meta.request.needle.id');
          store.dispatch(entitiesDelete(schema, payload));
        }
      } else {
        const { result, entities } = normalize(payload, Array.isArray(payload) ? [schema] : schema);
        store.dispatch(entitiesReceive(entities, action));
        return next({ ...action, payload: result });
      }
    } else if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(`[entities] There is no ${camelEntity} schema on schemas.js`);
    }
  }
  return next(action);
};

export default middleware;
